export default class ErpLogEntity {
    static getEntityData(elem: any) {
        return {
            id: elem.querySelector("#erp_log_id") ? (elem.querySelector("#erp_log_id") as HTMLInputElement).value : null,
        }
    }
}